import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { selectLogInUsername } from "../../../../common/authenticateDashboard/authSlice";
import { LoadingAnimation } from "../../../../components/Loading/LoadingAnimation";
import { VisitorsNumbersByMediumGraph } from "../../../../components/Graphs/graphs";
import {
  SelectUTMMediumStatus,
  SelectVisitors,
  SelectPercentBooking,
  SelectPercentBought,
  SelectWeeks,
  SelectLabels,
  graphUTMMedium,
} from "./utmMediumSlice";
import { SingleGraphLoading } from "../../../../components/Skeletons";

const UTMMedium = ({ display }) => {
  const dispatch = useDispatch();
  const sessionUser = useSelector(selectLogInUsername);
  const user = sessionUser?.split("@")[0];
    
//   const UTMMediumData = useSelector((state) => state.utmMedium);
  const loading = useSelector(SelectUTMMediumStatus);
  const weeks = useSelector(SelectWeeks);
  const visitors = useSelector(SelectVisitors);
  const percentBooking = useSelector(SelectPercentBooking);
  const percentBought = useSelector(SelectPercentBought);
  const adsLabels = useSelector(SelectLabels);

  useEffect(() => {
    if (!user) return null;
    if(weeks.length===0) dispatch(graphUTMMedium(user));
  }, [user, weeks]);

  if (loading === "loading") return <SingleGraphLoading />;

  return (
    <VisitorsNumbersByMediumGraph
      loading={loading === "loading"}
      display={display}
      weeks={weeks}
      visitors={visitors}
      percentOfBooking={percentBooking}
      nameLabels={adsLabels}
      totalSales={percentBought}
      />
  );
};

export default UTMMedium;